const initialState = {
    searchSuggestionsData: [],
    count: 0,
    page: 0,
    isLoading: false,
    getQuestionUuid: null,
    source: '',
    domainIds: [],
    fromDate: "",
    tillDate: "",
    rowsPerPage: 20,
    isAccepted: null,
    excludeEmail: true,
    searchSuggestionDetails: [],
    questionText: '',
    seekerName: '',
    userType: '',
    postedDate: 0,
    tags: "",
    ratings: null,
    geoLevelId: 3,
    geoLevelValue: '',
    seekers: [],
    seekersListInfo: [],
    experts: [],
    expertsListInfo: [],
    domainNames: [],
    askedSource: "",
    isComingBack: false,
    isItemsDelete: false,
    deletedQuestions: [],
    isAPICalled: false,
    isEmpty: false,
    getDislikes: false,
    includeDomainName: "",
    genAISummary: "",
    genAIOverallRating: 0,
    genAIToggle: false,
    bestResultToggle: false,
    qSubmitted:false,
    keyTags:[]
};

const searchSuggestionsCM = (state = initialState, action) => {
    switch (action.type) {
        case "getSearchSuggestionKeytag":
            state = { ...state, keyTags: action.payload }
            return state;
        case "suggestionsData":
            state = { ...state, searchSuggestionsData: action.payload }
            return state;
        case "getSuggestionsCount":
            state = { ...state, count: action.payload };
            return state;
        case "updatePageNoSearchSuggestions":
            state = { ...state, page: action.payload };
            return state;
        case "loadingStatusForSearchSuggestions":
            state = { ...state, isLoading: action.payload };
            return state;
        case "getQuestionUuidForSearchSuggestions":
            state = { ...state, getQuestionUuid: action.payload };
            return state;
        case "getSourceTypeForSearchFilter":
            state = { ...state, source: action.payload };
            return state;
        case "getSourceTypeForDomainIds":
            state = { ...state, domainIds: action.payload };
            return state;
        case "getSourceTypeForFromDate":
            state = { ...state, fromDate: action.payload };
            return state;
        case "getSourceTypeForTillDate":
            state = { ...state, tillDate: action.payload };
            return state;
        case "updateRowsPerPage":
            state = { ...state, rowsPerPage: action.payload };
            return state;
        case "getSourceTypeForAccepted":
            state = { ...state, isAccepted: action.payload };
            return state;
        case "getSourceTypeForEmail":
            state = { ...state, excludeEmail: action.payload };
            return state;
        case "searchSuggestionDetailsData":
            state = { ...state, searchSuggestionDetails: action.payload }
            return state;
        case "getQuestionTextInSearchSuggestions":
            state = { ...state, questionText: action.payload }
            return state;
        case "getSeekerNameInSearchSuggestionsData":
            state = { ...state, seekerName: action.payload }
            return state;
        case "getUserTypeInSearchSuggestions":
            state = { ...state, userType: action.payload }
            return state;
        case "getPostedDateInSearchSuggestions":
            state = { ...state, postedDate: action.payload }
            return state;
        case "getTagsInSuggestions":
            state = { ...state, tags: action.payload }
            return state;
        case "getRatingsInSearchSuggestions":
            state = { ...state, ratings: action.payload }
            return state;
        case "clearRatingsDataInSearchSuggestions":
            state = { ...state, seekersListInfo: initialState.seekersListInfo }
            state = { ...state, seekers: initialState.seekers }
            return state;
        case "getGeoLevelId":
            state = { ...state, geoLevelId: action.payload }
            return state;
        case "getGeoLevelValue":
            state = { ...state, geoLevelValue: action.payload }
            return state;
        case "getFilterForSeekers":
            state = { ...state, seekers: action.payload }
            return state;
        case "getSeekerListInfo":
            state = { ...state, seekersListInfo: action.payload }
            return state;
        case "getFilterForExperts":
            state = { ...state, experts: action.payload }
            return state;
        case "getExpertListInfo":
            state = { ...state, expertsListInfo: action.payload }
            return state;
        case "getDomainNameInSearch":
            state = { ...state, domainNames: action.payload }
            return state;
        case "getAskedSourceInSearchSuggestions":
            state = { ...state, askedSource: action.payload }
            return state;
        case "clearExpertsListData":
            state = { ...state, expertsListInfo: initialState.expertsListInfo }
            state = { ...state, experts: initialState.experts }
            return state;
        case "checkIfComingBack":
            state = { ...state, isComingBack: action.payload }
            return state;
        case "getCheckForDeletedItemsCM":
            state = { ...state, isItemsDelete: action.payload }
            return state;
        case "getDeletedItemsListInSearch":
            state = { ...state, deletedQuestions: action.payload }
            return state;
        case "clearDeletedItemsFromArray":
            state = { ...state, deletedQuestions: [] }
            return state;
        case "checkDeleteAPICall":
            state = { ...state, isAPICalled: action.payload }
            return state;
        case "showEmptySuggestions":
            state = { ...state, isEmpty: action.payload }
            return state;
        case "getDislikesData":
            state = { ...state, getDislikes: action.payload }
            return state;
        case "getDomainNameInfo":
            state = { ...state, includeDomainName: action.payload }
            return state;
        case "getGenAISummary":
            state = { ...state, genAISummary: action.payload }
            return state;
        case "genAIOverallRatings":
            state = { ...state, genAIOverallRating: action.payload }
            return state;
        case "genAIAnswerToggle":
            state = { ...state, genAIToggle: action.payload }
            return state;
        case "bestResultsToggle":
            state = { ...state, bestResultToggle: action.payload }
            return state;
        case "questionsSubmittedFilter":
            state = {...state,qSubmitted:action.payload }
            return state;
        default:
            return state;
    }
}
export default searchSuggestionsCM;